module.exports = __webpack_public_path__ + "static/media/Jellyfish_2_t.8ac80930.jpg";